import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { ModifyValue } from 'containers/ProductDetail/hooks/useProductDetaillHooks';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import ProfileUpdateContainer from 'containers/Menu/components/ProfileUpdateContainer';
import { Product } from 'types/api';
import HackleManager from 'utils/hackle';
import ModalHeader from './ModalHeader';
import TitleContainer from 'containers/ProductRegist/components/TitleContainer';
interface ProfileModifyFormIProps {
  isMobile: boolean;
  modifyValue: ModifyValue;
  productInfo: Product;
  setModifyValue: Dispatch<SetStateAction<ModifyValue>>;
}

const ProfileModifyForm: React.FC<ProfileModifyFormIProps> = props => {
  const { isMobile, modifyValue, productInfo, setModifyValue } = props;

  useEffect(() => {
    HackleManager.logProductModifyHostProfileView(
      Number(productInfo.id),
      productInfo.title,
    );
  }, []);

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <ModalContainer
          isMobile={isMobile}
          isAbled={true}
          isBottomSheet={true}
          onClose={() => {
            setModifyValue({ ...modifyValue, modifyStatus: '' });
          }}
          onCloseText=" "
          onAcceptText="적용"
          onClick={() => {
            HackleManager.logProductModifyItemSaveComplete(
              Number(productInfo.id),
              productInfo.title,
              '프로필',
            );
            setModifyValue({ ...modifyValue, modifyStatus: 'profile' });
          }}
        >
          <Column>
            <ModalHeader
              title="프로필 수정하기"
              modifyValue={modifyValue}
              setModifyValue={setModifyValue}
              style={{ padding: '24px 20px', zIndex: 10 }}
            />
            <ProfileUpdateContainer
              isMobile={isMobile}
              type="modify"
              onClose={() =>
                setModifyValue({ ...modifyValue, modifyStatus: '' })
              }
            />
          </Column>
        </ModalContainer>
      );
    }

    return (
      <Column>
        <TitleContainer
          title="프로필 수정하기"
          isMobile={isMobile}
          style={{ padding: '32px 40px' }}
        />
        <Column>
          <ProfileUpdateContainer
            isMobile={isMobile}
            type="modify"
            onClose={() => {
              HackleManager.logProductModifyItemSaveComplete(
                Number(productInfo.id),
                productInfo.title,
                '프로필',
              );
              setModifyValue({ ...modifyValue, modifyStatus: 'profile' });
            }}
          />
        </Column>
      </Column>
    );
  };

  return renderContents();
};

export default ProfileModifyForm;
